import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const BillingCancel = () => (
  <div className="min-h-screen bg-[#faf8f5] text-[#1c1917]">
    <main className="mx-auto max-w-lg px-4 py-16 text-center sm:px-6">
      <h1 className="font-serif text-2xl text-[#1c1917]">Checkout cancelled</h1>
      <p className="mt-2 text-sm leading-relaxed text-[#5c534a]">
        No charges were made. You can return to pricing whenever you are ready.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
        <Link to="/pricing">
          <Button className="h-12 w-full rounded-full bg-[#1c1917] text-[#faf7f2] hover:bg-[#2c2824] sm:w-auto">
            Back to pricing
          </Button>
        </Link>
        <Link to="/dashboard">
          <Button variant="outline" className="h-12 w-full rounded-full border-[#c9a961]/40 sm:w-auto">
            Dashboard
          </Button>
        </Link>
      </div>
    </main>
  </div>
);

export default BillingCancel;
